import { render, staticRenderFns } from "./complete-profile-redirect.vue?vue&type=template&id=6db29f3c&lang=pug&"
import script from "./complete-profile-redirect.vue?vue&type=script&lang=js&"
export * from "./complete-profile-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports